import i18n from '../../../../i18n';
const previewWrapperSelector = '.js-steady_login_preview_wrapper';
const sizeInputSelector = '.js-steady_login_preview_size';
const languageInputSelector = '.js-steady_login_preview_language';
const codeSelector = '.js-steady_login_code';
const previewSelector = '.js-steady_login_preview';
const previewTextSelector = '.js-steady_login_preview_text';
const previewClass = 'backend_publication_steady_login_settings__preview';
const possibleSizes = ['small', 'medium', 'large'];
const updatePreviewLanguage = (previewText, language) => {
    i18n.setLocale(language);
    previewText.textContent = i18n.$gettext('Log in with Steady');
    i18n.setLocale(window.locale);
};
const updatePreviewSize = (preview, size) => {
    possibleSizes.forEach(possibleSize => {
        preview.classList.remove(`${previewClass}--${possibleSize}`);
    });
    preview.classList.add(`${previewClass}--${size}`);
};
const updateCodeLanguage = (code, language) => {
    if (code.textContent) {
        code.textContent = code.textContent.replace(/data-language="([^"]+)"/, `data-language="${language}"`);
    }
};
const updateCodeSize = (code, size) => {
    if (code.textContent) {
        code.textContent = code.textContent.replace(/data-size="([^"]+)"/, `data-size="${size}"`);
    }
};
window.up.compiler(previewWrapperSelector, (wrapper) => {
    const sizeInputs = wrapper.querySelectorAll(sizeInputSelector);
    const languageInput = wrapper.querySelector(languageInputSelector);
    const preview = wrapper.querySelector(previewSelector);
    const previewText = wrapper.querySelector(previewTextSelector);
    const code = wrapper.querySelector(codeSelector);
    if (preview && previewText && languageInput && code) {
        updatePreviewLanguage(previewText, languageInput.value);
        updateCodeLanguage(code, languageInput.value);
        window.up.on(languageInput, 'change', undefined, () => {
            updatePreviewLanguage(previewText, languageInput.value);
            updateCodeLanguage(code, languageInput.value);
        });
        sizeInputs.forEach(sizeInput => {
            window.up.on(sizeInput, 'change', undefined, () => {
                updatePreviewSize(preview, sizeInput.value);
                updateCodeSize(code, sizeInput.value);
            });
        });
    }
});
